import {OptimizationSpecialistAreaDashboard} from '@features/optimization-specialist-dashboard'
import {useTranslation} from 'react-i18next'

import {useTranslationPrefix} from '../../../shared/hooks'
import {LocationBreadcrumbs} from '../../components'
import {useHrocMapMarkersData} from '../../hooks'
import {AREA_ROUTE_SEGMENTS, OPTIMIZATION_SPECIALIST_DASHBOARD} from '../../routing'

export const AreaOptimizationSpecialistDashboard = () => {
  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  return (
    <OptimizationSpecialistAreaDashboard
      title={t(`${hrocPrefix}.optimizationSpecialistDashboard.pageTitle`)}
      dashboardRoute={OPTIMIZATION_SPECIALIST_DASHBOARD}
      routeSegments={AREA_ROUTE_SEGMENTS}
      fallbackBreadcrumbs={<LocationBreadcrumbs sx={{ml: 0}} />}
      useMapMarkersDataHook={useHrocMapMarkersData}
    />
  )
}
